const withPrefix = (key: string): string => `boltbox.${key}`;

export const getFromLocalStorage = (key: string): string => {
  return localStorage.getItem(withPrefix(key)) || '';
};

export const saveToLocalStorage = (key: string, value: string): void => {
  return localStorage.setItem(withPrefix(key), value);
};
